import parseISO from "date-fns/parseISO";
import formatDate from '@utils/format-date'
import _groupBy from "lodash/groupBy";

export function prepaidHasInventory({
  infinity,
  qty,
  inventory
} = {}) {
  return infinity || qty < inventory
}

export function prepaidIsExpired(expiredDate) {
  return expiredDate
    ? new Date() > parseISO(expiredDate)
    : false
}

export function prepaidFormatExpiredDate({ expiredDate, expiredDays, status, showExpiredText }) {
  const isUnpaid = status === 2 || status === undefined;
  const expiredText = showExpiredText && prepaidIsExpired(expiredDate)
    ? '(已過期)'
    : '';

  const dateText = () => {
    if(isUnpaid) {
      return expiredDays > 0
        ? `付款日+${expiredDays}天`
        : '無期限';
    } else {
      return expiredDate
        ? formatDate(expiredDate, 'yyyy/MM/dd')
        : '無期限';
    }
  };

  return `${dateText()}${expiredText}`
}

export function prepaidFormatUsedTimes(usedTimes) {
  return Number(usedTimes) > 99
    ? '99+'
    : usedTimes;
}

export function prepaidUsedStepList({ times, history } = {}) {
  const usedHistoryList = history.filter(item => {
    return item.status !== 0
  });

  return Array.from({ length: times })
    .map((item, index) => {
      return {
        title: usedHistoryList[index]
          ? `${formatDate(usedHistoryList[index].createdDate, 'yyyy/MM/dd')} 已使用`
          : '',
        value: index
      }
    })
}

export function prepaidApplicableEventGroup(applicableEvents) {
  return applicableEvents
    ? _groupBy(applicableEvents, 'groupId')
    : {}
}

export function prepaidFormatUsageRules(usageRules) {
  return usageRules && usageRules[0]
    ? usageRules.filter(item => {
      return item.state && item.type === 'exclude'
    })
    : []
}


export function prepaidFormatGroupAlias(alias = '') {
  return alias.replace(/-\w+$/, '');
  // const [nameA = '', nameB = '', storeType = '', pet = ''] = alias.split('-');
  // return `${storeType}-${nameA}-${pet}-${nameB}`
}
